import classNames from 'classnames';
import translate, { t } from '../../../../utilities/translator';

const FilterModal = (props) => {
  const {
    children,
    className,
    title,
    footerTxt,
    saveBtnTxt,
    onClose,
    onClear,
    onSave,
    disableSave,
    showSaveLogin = false,
    onSaveLogin,
  } = props;
  return (
    <div className={classNames("filter-modal-wrap", { [className]: className })} role="dialog" aria-modal="true" aria-labelledby="fm-title-txt">
      <div className="fm-bg" onClick={onClose} aria-label="Close" />
      <div className="filter-modal">
        <div className="fm-header flex justify-between items-center gap-5 p-3">
          <span className="fm-close ms-auto" onClick={onClose} aria-label="Close">
            <i className="ri-close-line" />
          </span>
        </div>
        <div className="fm-body px-5 pb-3">
          <div className="fm-title flex flex-col gap-3 mb-5">
            <span id="fm-title-txt">{title}</span>
            <div>{t('mainFilter.multipleOptionsAvailable')}</div>
          </div>
          {children}
        </div>
        <div className="fm-footer flex justify-between items-center p-5">
          <div className="fmf-txt">{/* footerTxt */}</div>
          <div className="fmf-buttons flex items-center gap-3">
            <button className="fmf-clear py-4 px-6 rounded-full" onClick={onClear}>
              {translate('holidayFinder.buttons.Clear')}
            </button>
            <button className="fmf-save py-4 px-6 rounded-full" onClick={disableSave ? () => false : onSave} disabled={disableSave}>
              {saveBtnTxt}
            </button>
            {showSaveLogin && <button className="fmf-save-login py-4 px-6 rounded-full" onClick={onSaveLogin}>{translate('holidayFinder.mainFilter.savePreferences')}</button>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
